import {
	Button,
	DetailsCard,
	H4,
	Modal,
	ModalContent,
	ModalFooter,
	ModalTitle,
	TextRegular,
	TextSemiBold,
} from "@hm/fundamental"
import { APP_NAME_COMMON } from "@shared/config"
import { useTranslation } from "react-i18next"

interface AccountabilityModalProps {
	isModalOpen: boolean
	onClose: () => void
}

export const AccountabilityModal: React.FC<AccountabilityModalProps> = ({
	isModalOpen,
	onClose,
}) => {
	const { t } = useTranslation("shared", {
		keyPrefix: "accountabilityModal",
	})

	return (
		<Modal
			data-cy="accountability-modal"
			className="!w-[816px]"
			open={isModalOpen}
			onClose={onClose}
		>
			<ModalTitle data-cy="accountability-modal-title" className="pt-0">
				{t("title1", { productName: APP_NAME_COMMON })}
			</ModalTitle>
			<ModalContent data-cy="accountability-modal-content">
				<div className="flex flex-col gap-6">
					<TextRegular className="block">
						{t("paragraph1", { productName: APP_NAME_COMMON })}
					</TextRegular>
					<div>
						<TextRegular className="block">
							{t("paragraph2")}
						</TextRegular>
						<TextRegular className="block">
							{t("paragraph3")}
						</TextRegular>
					</div>
					<TextRegular className="block">
						{t("paragraph4")}
					</TextRegular>
					<TextRegular className="block">
						{t("paragraph5")}
					</TextRegular>
					<H4 className="block text-foreground">{t("title2")}</H4>
					<TextRegular>
						{t("paragraph6")}{" "}
						<TextSemiBold className="text-foreground">
							{t("paragraph6Bold")}
						</TextSemiBold>
					</TextRegular>
					<div className="flex max-md:flex-col gap-6">
						<div className="md:w-[50%]">
							<TextSemiBold className="text-foreground">
								{t("paragraph7Bold")}
							</TextSemiBold>
							<TextRegular>{t("paragraph7")}</TextRegular>
						</div>

						<DetailsCard className="md:w-[50%]">
							<TextRegular className="text-foreground">
								{t("paragraph8")}
							</TextRegular>
						</DetailsCard>
					</div>
				</div>
			</ModalContent>
			<ModalFooter
				data-cy="accountability-modal-footer"
				className="max-md:flex-col max-md:w-full"
			>
				<Button
					onClick={onClose}
					data-cy="accountability-modal-button-close"
				>
					{t("close")}
				</Button>
			</ModalFooter>
		</Modal>
	)
}
